// Packages
import PageNotFoundPage from "../Common/PageNotFoundPage";
import SchoolAdminContainer from "../containers/SuperAdmin/SchoolAdmin";
import { getFromLocalStorage } from "../utils/webStorage";

function index() {
  const loginRole = getFromLocalStorage("loginRole");
  return (
    <>
      {loginRole === "SUPER ADMIN" ? (
        <SchoolAdminContainer />
      ) : (
        <PageNotFoundPage />
      )}
    </>
  );
}

export default index;
